export default __webpack_public_path__ + "static/media/warning--height-restriction--g3.71fa9500.png";